export enum UserInvitePersonaType {
  ADMIN = "admin",
  CANDIDATE = "candidate",
  ORG_MEMBER = "org_member",
  TEAM_MEMBER = "team_member",
  PROJECT_ADMIN = "project_admin",
}

export enum UserSignupPersonaType {
  PERSONAL = "personal",
  DISCOVERY = "discovery",
  HIRING = "hiring",
  TEAM_DEVELOPMENT = "team_development",
}

export type UserPersonaType = UserInvitePersonaType | UserSignupPersonaType;
